import TransportModeIcon from './TransportModeIcon'

export default TransportModeIcon
